import store from '@/store';
import { valueType } from '../constants';
export const formatPercent = (value, options) => {
    const DEFAULT_LANGUAGE = {
        locale: 'pt-BR',
    };
    const { locale } = store.getters?.currency || DEFAULT_LANGUAGE;
    const percentValue = value ? (typeof value === 'string' ? parseFloat(value.replace(',', '.')) : value) : 0;
    const formatting = {
        style: valueType.percent,
        maximumFractionDigits: options ? options : undefined,
    };
    const result = new Intl.NumberFormat(locale, formatting).format(percentValue);
    return result;
};
